<!--  -->
<template>
  <div class="skeleton">
    <div class="skeleton-header">
      <div class="center"></div>
    </div>
    <ul class="skeleton-part1 mt5">
      <li v-for="i in 8" :key="i">
        <div class="left"></div>
        <div class="right">
          <p v-for="(i,index) in [221,221]" :key="index" :style="{width:i/100+'rem'}"></p>
          <div class="three">
            <p v-for="(i,index) in [73,73]" :key="index" :style="{width:i/100+'rem'}"></p>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'area-skeleton',
  components: {},

  props: {},

  data () {
    return {
    }
  },

  computed: {},

  watch: {},

  created () {},

  methods: {}
}

</script>
<style lang='scss' scoped>
  .skeleton{
    @include skeletonBlink();
    overflow: hidden;
    position: relative;
    &-header{
      height: 45px;
      width: 100%;
      background: var(--APP_skeleton_color);
      @include center();
      .center{
        width: 300px;
        height: 24px;
        border-radius: 3px;
        background:var(--APP_skeleton_background_color);
      }
    }

    &-part1{
      border-radius: 10px;
      width: 100%;
      li{
        background: var(--APP_skeleton_background_color);
        height: 129px;
        margin: 10px;
        display: flex;
        box-sizing: border-box;
        border-radius: 10px;
        padding: 20px 0 20px 10px;
        position: relative;
        .left{
          width: 85px;
          height: 85px;
          border-radius: 3px;
          background: var(--APP_skeleton_color);
        }
        .right{
          flex: 1;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding-bottom: 15px;
          margin-left: 27px;
          p{
            height: 15px;
            background: var(--APP_skeleton_color);
          }
          .three{
            display: flex;
            p{
              margin-right: 10px;
            }
          }
        }
        .btn{
          position: absolute;
          bottom: 15px;
          right: 10px;
          display: inline-block;
          height: 24px;
          width: 78px;
          background: var(--APP_skeleton_color);
          border-radius: 3px;
        }
      }
    }
  }
</style>
